//replaces change.html
import classNames from "classnames";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import type { FC } from "react";

interface IChangeCellTemplate {
    data: any;
    row: any;
}
export const ChangeCellTemplateV2: FC<IChangeCellTemplate> = (props) => {
    const { data, row } = props;

    return (
        <div
            className={classNames({
                "arrow--negative": data[row.field] < 0,
                "arrow--positive": data[row.field] > 0,
            })}
        >
            <span className="singleMetric-cell--value">{dynamicFilterFilter()(data[row.field], row.format)}</span>
        </div>
    );
};
